// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

const TransactionListHead = () => {
  const t = useTranslate();

  return (
    <div className="TransactionListHead">
      <div className="TransactionListHead__title">
        {t("profile.balance.history.method")}
      </div>
      <div className="TransactionListHead__title">ID</div>
      <div className="TransactionListHead__title">
        {t("profile.balance.history.created")}
      </div>
      <div className="TransactionListHead__title">
        {t("profile.balance.history.amount")}
      </div>
      <div className="TransactionListHead__title">
        {t("profile.balance.history.status")}
      </div>
    </div>
  );
};

export default TransactionListHead;
